import { render, staticRenderFns } from "./BrandManage.vue?vue&type=template&id=0bf9b67c&scoped=true"
import script from "./BrandManage.vue?vue&type=script&lang=js"
export * from "./BrandManage.vue?vue&type=script&lang=js"
import style0 from "./BrandManage.vue?vue&type=style&index=0&id=0bf9b67c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9b67c",
  null
  
)

export default component.exports